(function() {
    var cookiePrefix = 'akw_';

    /**
     * Define the mapping of parameters to field names
     * Keys = URL parameter names
     * Values = Form field names (matched via input[data-utm-field="..."])
     */
    var paramFieldMapping = {
        'utm_source': 'utm_source',
        'utm_medium': 'utm_medium',
        'utm_campaign': 'utm_campaign',
        'utm_content': 'utm_content',
        'utm_term': 'utm_term',
        'gclid': 'gclid_field'
    };

    // Function to get URL parameters
    function getUrlParam(name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
            return null;
        }
        return decodeURI(results[1]) || 0;
    }

    // Function to set a cookie
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = cookiePrefix + name + "=" + (value || "") + expires + "; path=/";
    }

    // Function to get a cookie value
    function getCookie(name) {
        var nameEQ = cookiePrefix + name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Function to capture and store parameters
    function captureParameters() {
        Object.keys(paramFieldMapping).forEach(function(param) {
            var value = getUrlParam(param);
            if (value) {
                setCookie(param, value, 15); // Store for 15 days
            }
        });
    }

    // Function to populate the form fields
    function populateFields() {
        Object.entries(paramFieldMapping).forEach(function([param, fieldName]) {
            var value = getCookie(param);
            if (!value) return;

            document.querySelectorAll('input[data-utm-field="' + fieldName + '"]').forEach(function(input) {
                input.value = value;
            });
        });
    }

    // Main function to handle parameters
    function handleParameters() {
        // capture parameters and store them in cookies for 15 days
        captureParameters();

        // populate the form fields with the parameter values
        populateFields();
    }

    // Run the handler when the DOM is fully loaded
    document.addEventListener('DOMContentLoaded', handleParameters);

    // Also run the handler when the page is fully loaded (including images and iframes)
    window.addEventListener('load', handleParameters);
})();
